class ServiceWorkerError extends Error {
    constructor() {
        super("Browser doenst support Service Worker");
        this.name = 'ServiceWorkerError'
        this.code = 'browser-no-support'
    }
}

export async function registerServiceWorker() {
    if ('serviceWorker' in navigator) {
        let registration = await navigator.serviceWorker.register('/service-worker.js')

        let serviceWorker = registration.installing || registration.waiting || registration.active;

        if (!serviceWorker) {
            return registration
        }

        await (new Promise(resolve => {
            serviceWorker.addEventListener("statechange", (e) => {
                if (e.target.state === "activated") {
                    resolve()
                }
            })

            if (serviceWorker.state === 'activated' || serviceWorker.state === 'installed') {
                resolve()
            }
        }))

        return registration
    }

    throw new ServiceWorkerError()
}
